'use client'

import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination } from 'swiper/modules'

// Import Swiper styles
// import 'swiper/css'
// import 'swiper/css/navigation'
// import 'swiper/css/pagination'

function getYouTubeEmbedUrl(url) {
  if (!url) return null

  const shortsMatch = url.match(/youtube\.com\/shorts\/([a-zA-Z0-9_-]+)/)
  if (shortsMatch) return `https://www.youtube.com/embed/${shortsMatch[1]}`

  const watchMatch = url.match(/[?&]v=([a-zA-Z0-9_-]+)/)
  if (watchMatch) return `https://www.youtube.com/embed/${watchMatch[1]}`

  const shortMatch = url.match(/youtu\.be\/([a-zA-Z0-9_-]+)/)
  if (shortMatch) return `https://www.youtube.com/embed/${shortMatch[1]}`

  return null
}

export default function CourseTestimonialVideos({ course }) {
  const testimonials = course?.testimonials || []

  if (!testimonials.length) return null

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-3">
            What Our Students Say
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Hear directly from Medhaavians about their journey at MSU
          </p>
        </div>

        {/* Swiper */}
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={20}
          slidesPerView="auto"
          navigation
          pagination={{ clickable: true }}
          className="!pb-12"
        >
          {testimonials.map((testimonial, index) => {
            const embedUrl = getYouTubeEmbedUrl(testimonial.video_url)
            if (!embedUrl) return null

            return (
              <SwiperSlide
                key={testimonial.id || index}
                className="!w-[280px] sm:!w-[300px]"
              >
                <div className="bg-white rounded-2xl overflow-hidden shadow-md border border-gray-100">
                  {/* 9:16 vertical ratio for Shorts */}
                  <div className="relative w-full" style={{ paddingTop: '177.78%' }}>
                    <iframe
                      className="absolute inset-0 w-full h-full"
                      src={embedUrl}
                      title={`Student Testimonial ${index + 1}`}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                </div>
              </SwiperSlide>
            )
          })}
        </Swiper>

      </div>
    </section>
  )
}